module.exports = __webpack_public_path__ + "static/media/textpage.2593a605.png";